import { EventStream, Tuple3 } from '@cgs/wge';

export class ClientConfigPropertyDTO {
  isDefault: boolean;
  key: string;
  type: string;
  value: string;
}

export const T_IClientProperties = Symbol('IClientProperties');
export interface IClientProperties {
  updateProperties(properties: ClientConfigPropertyDTO[], shouldRemove?: boolean): void;

  propertyChanged: EventStream<Tuple3<string, string, string>>;

  propertiesUpdated: EventStream<any>;

  [key: string]: any;

  get(key: string, defOrType?: any): any;

  // getConv(key: string, type?: Type, def?: any): any;

  keyExists(key: string): boolean;

  setLocal(key: string, value: any): void;

  isFeatureEnabled(key: string, def?: boolean): boolean;

  getBackTracking(keys: string[], defOrType?: any): any;
}
